import { publicApi } from "@api";
import { envConfig } from "@configs/env";
import { DeployEnv } from "@types";

interface UseServerConfigProps {
  skip?: boolean;
}

/**
 * Get server config from kz-config repository
 * Repo: https://github.com/99techteam/kz-config
 */
export const useServerConfig = ({ skip }: UseServerConfigProps = {}) => {
  const queryResult = publicApi.useGetServerConfigQuery(
    {
      group: envConfig.brand.group,
      accountId: envConfig.accountId,
      env: envConfig.deploymentEnv,
    },
    {
      skip: skip ?? envConfig.deploymentEnv === DeployEnv.Local,
    },
  );

  return queryResult;
};
